export default __webpack_public_path__ + "static/media/rd.c82850c8.png";